module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.linesLoading),
      expression: "linesLoading"
    }],
    staticClass: "product-lines-loading-wrap",
    staticStyle: {
      "width": "100%",
      "min-height": "220px",
      "position": "relative"
    },
    attrs: {
      "element-loading-text": _vm.$t('static.loadingProductLines')
    }
  }, [_c('v-form-table', {
    ref: "formTable",
    staticClass: "orderproduct-table",
    attrs: {
      "form": _vm.form,
      "list": _vm.list,
      "additionalButtons": _vm.additionalButtons,
      "update": _vm.update,
      "destroy": _vm.order.orderStatus === 'created' ? _vm.destroy : null,
      "hiddenFields": _vm.hiddenFields,
      "translation": "table.orderProducts",
      "disableForm": (_vm.order.isBilled || _vm.order.orderType === 'Wordpress' || (_vm.order.orderType == 'Return' && _vm.order.orderStatus == 'completed')) ? true : false,
      "stack": {
        name: 'note',
        price: 'productDepositName'
      },
      "clickHandler": _vm.tableClickHandler
    }
  }), _vm._v(" "), _c('v-totals-table', {
    attrs: {
      "list": _vm.totalsTableList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dd43ecb","hasScoped":false}!./src/app/components/orderProductsTable/orderProductsTable.html
// module id = 2994
// module chunks = 1